// extracted by mini-css-extract-plugin
module.exports = {"green":"utils_green__g_0Sb","red":"utils_red__3jLnw","yellow":"utils_yellow__2zwVV","yellowishGreen":"utils_yellowishGreen__3qv1J","gray":"utils_gray__2v2j6"};